import { computeCapabilityDimensionsDiff } from "./blueprintDiffUtils";
import type { BlueprintVersion } from "./blueprintTypes";

interface BlueprintVersionDiffProps {
  oldVersion: BlueprintVersion;
  newVersion: BlueprintVersion;
}

export function BlueprintVersionDiff({ oldVersion, newVersion }: BlueprintVersionDiffProps) {
  const dimensionDiffs = computeCapabilityDimensionsDiff(
    oldVersion.capabilityDimensions ?? [],
    newVersion.capabilityDimensions ?? [],
  );
  const hasChanges = dimensionDiffs.length > 0;

  return (
    <div className="space-y-3">
      <h4 className="text-xs font-medium text-text-secondary">
        Changes from v{oldVersion.versionNumber} to v{newVersion.versionNumber}
      </h4>

      {!hasChanges && <p className="text-xs text-text-muted">No changes</p>}

      {dimensionDiffs.length > 0 && (
        <div>
          <span className="text-xs font-medium text-text-muted">Capability Dimensions</span>
          <div className="mt-1 space-y-2">
            {dimensionDiffs.map((dim) => (
              <div
                key={dim.name}
                className={`rounded border px-2 py-1.5 text-xs ${
                  dim.added
                    ? "border-green-200 bg-green-50 dark:border-green-800 dark:bg-green-900/20"
                    : dim.removed
                      ? "border-red-200 bg-red-50 dark:border-red-800 dark:bg-red-900/20"
                      : "border-border"
                }`}
              >
                <span className="font-medium text-text-primary">
                  {dim.added && "+ "}
                  {dim.removed && "− "}
                  {dim.name}
                </span>
                {dim.fieldChanges.length > 0 && (
                  <div className="mt-1 space-y-0.5">
                    {dim.fieldChanges.map((fc) => (
                      <div key={fc.label} className="text-text-muted">
                        <span className="font-medium">{fc.label}:</span>{" "}
                        {fc.oldValue ? (
                          <span className="bg-red-100 text-red-800 line-through dark:bg-red-900/30 dark:text-red-400">
                            {fc.oldValue}
                          </span>
                        ) : (
                          <span className="italic text-text-faint">empty</span>
                        )}
                        {" → "}
                        {fc.newValue ? (
                          <span className="bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400">
                            {fc.newValue}
                          </span>
                        ) : (
                          <span className="italic text-text-faint">empty</span>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
